/**
 *  Pool Widget data parser to get:
 *  - links
 *  - news with ai
 *  - score points and rows
 */
import { ICoin, ITokenInfo, ITokenScore, Network } from '@kattana-io/common';
import { IPoolCoinInfo, IPoolWidgetScore } from '../useTickerPool';
import { getScoreRows } from './rows';
import IconProvider from '../../../helpers/IconProvider';

const getCexPoolInfo = (coin?: ICoin): IPoolCoinInfo => {
  const coinInfo: IPoolCoinInfo = {
    links: null,
    news: null,
  };
  if (coin) {
    coinInfo.links = {
      website: coin.website,
      coingecko_id: coin.coingecko_id,
      coinmarketcap_id: coin.coinmarketcap_id,
      telegram: coin.telegram,
      twitter_id: coin.twitter_id,
      logo: coin.logo_url,
    };
    if (coin.has_news && coin.news) {
      coinInfo.news = {
        ai: coin.AI,
        items: coin.news,
      };
    }
  }
  return coinInfo;
};

const getDexPoolInfo = (
  coin: ITokenInfo | null,
  chain: string,
  baseAddress: string
): IPoolCoinInfo => {
  const coinInfo: IPoolCoinInfo = {
    links: null,
    news: null,
  };
  if (coin) {
    coinInfo.links = {
      website: coin.website,
      coingecko_id: coin.coingecko_id,
      coinmarketcap_id: coin.coinmarketcap_id,
      telegram: coin.telegram,
      twitter_id: coin.twitter_id,
    };
    if (coin.logo_url) {
      coinInfo.links.logo = coin.logo_url;
    } else if (Network.isValidChain(chain)) {
      const network = Network.fromChain(chain);
      coinInfo.links.logo = IconProvider.createFromNetworkAndPair(
        network,
        baseAddress
      ).url();
    }
    if (coin.has_news && coin.news) {
      coinInfo.news = {
        ai: coin.AI,
        items: coin.news,
      };
    }
  }
  return coinInfo;
};

const getScoreInfo = (data: ITokenScore | null): IPoolWidgetScore | null => {
  let scoreInfo: IPoolWidgetScore | null = null;
  if (data) {
    scoreInfo = { points: data.points, rows: getScoreRows(data) };
  }
  return scoreInfo;
};

export { getCexPoolInfo, getDexPoolInfo, getScoreInfo };
